import axios from 'axios';
import { appendTokenToUrl } from '../components/context/Recaptcha';

const {
  additionalHeaders,
  loginRootUrl,
} = window.appAirDrop.config;

export interface SignInCodeData {
  ownerId: string;
  targetEmail?: string;
  phoneNumber?: string;
  countryCode?: string;
  escrowTicket: string;
  flowType: string;
}

export interface SignInCodeResponseData {
  status: string;
  data: SignInCodeData;
}

export async function SignInCode(signInCodeData: SignInCodeRequestData, recaptchaToken?: string) {
  // const loginRootUrl = 'https://dev-piapi-internal.dev-openclass.com';
  const path = `${loginRootUrl}/login/signinWithCode`;
  const response = await axios.post(
    appendTokenToUrl(path, recaptchaToken),
    signInCodeData,
    {
      headers: {
        ...(additionalHeaders ?? {}),
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    },
  );
  return response;
}

export interface RequestSignInCodeData {
  ownerId: string,
  targetEmail: string,
}

export interface RequestSignInCodeResponseData {
  status: string;
  data: RequestSignInCodeData;
}
export async function RequestSignInCode(requestSignInCodeRequestData: RequestSignInCodeRequestData, escrowTicket: string) {
  const path = `${loginRootUrl}/login/requestSignInCode/${escrowTicket}`;
  const formData = new URLSearchParams(requestSignInCodeRequestData).toString();
  const response = await axios.post(
    path,
    formData,
    {
      headers: {
        ...(additionalHeaders ?? {}),
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      withCredentials: true,
    },
  );
  return response;
}
